// extracted by mini-css-extract-plugin
export default {"container":"OrderItem_container__RChES","reviewItem":"OrderItem_reviewItem__+sXdV","cartItems":"OrderItem_cartItems__tDbrO"};